import logo from './logo.svg';
import './App.css';
import { base_url } from './url_variables';
import axios from 'axios';
import { useCookies } from "react-cookie";
import { useContext, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useParams, useLocation } from "react-router-dom";
import TostMessageComponent from "./TostMessageComponent/TostMessageComponent";
import Login from './screens/Login';
import Home from './screens/Home';
import OrderHistory from './screens/OrderHistory';
import OrderDetails from './screens/OrderDetails';
import ManageProducts from './screens/ManageProducts';
import AddProduct from './screens/AddNewProduct';
import ManageStaff from './screens/ManageStaff';
import { RiHome6Line } from "react-icons/ri";
import { TbHistoryToggle } from "react-icons/tb";
import { GiCash } from "react-icons/gi";
import { PiBuildingApartment } from "react-icons/pi";
import { MdOutlineWarehouse } from "react-icons/md";
import { UserContext } from "./context/UserContext";
import { MenuContext } from './context/MenuContext';
import { AiOutlineClose } from "react-icons/ai";
import club_logo from './images/Full-Colour Wordmark PNG.png'
import Dashboard from './screens/Dashboard';

function App() {
  const location = useLocation();
  const {userProfile, logOutFunction} = useContext(UserContext);
  const { menuOpen, setMenuOpen } = useContext(MenuContext)

  return (
    <div>
      {/* Main content */}
        {/* <ScrollToTop /> */}
        <TostMessageComponent />
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/dashboard/*" element={<Dashboard />} />

          <Route path="/*" element={<Login />} />
        </Routes>
    </div>
  );
}

export default App;
